import { useQuery } from "@tanstack/react-query"
import { api } from "@/api"

interface BillTextResponse {
    objects: object[]
    meta: object
}

const fetchBillHasText = async (billId: string): Promise<boolean> => {
    if (!billId) {
        return false
    }

    try {
        const response = await api.get(`/api/billtext/?bill=${billId}&limit=1&decode_enums=false`)
        const data: BillTextResponse = await response.json()

        const hasText = data.objects && data.objects.length > 0

        return hasText
    } catch (error) {
        console.error("Error checking if bill has text:", error)
        return false
    }
}

export const useBillHasText = (billId: string | undefined) => {
    return useQuery({
        queryKey: ["bill-has-text", billId],
        queryFn: () => fetchBillHasText(billId as string),
        enabled: Boolean(billId),
        staleTime: 5 * 60 * 1000, // 5 minutes - bill text doesn't change frequently
        refetchOnWindowFocus: false,
    })
}
